import { createFileRoute } from '@tanstack/react-router';

import privacy from '../content/privacy.md?raw';
import { LegalPage } from '../pages/LegalPage';

export const Route = createFileRoute('/legal/privacy')({
  component: () => <LegalPage markdown={privacy} title="Privacy Policy" />,
});
